<template>
  <div class="loading-container">
    <a-spin :tip="props.tip" :size="props.size" />
    <!-- <a-space> </a-space> -->
  </div>
</template>

<script setup>
const props = defineProps({
  tip: {
    type: String,
    default: "Loading...",
  },
  size: {
    type: String,
    default: "large",
  },
});
</script>
<style lang="less" scoped>
.loading-container {
  width: 100%;
  font-family: Galvji, sans-serif;
  font-size: 28px;
  color: #727171;
  // font-weight: bold;
  margin-bottom: 100px;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
}
// 加载图标边变红
:deep(.ant-spin-dot-item) {
  background-color: #c51e1e !important;
}
// 文案颜色修改
.ant-spin {
  color: #c51e1e;
}
</style>
